export class AdminGrowthInvestmentSummary {
  totalInvestmentAmount = 0

  subscriptionRevenueAmount = 0

  associatedRevenueAmount = 0

  totalReturnAmount = 0

  profitOrLossAmount = 0

  roiPercentage = 0

  investmentsCount = 0

  investmentLeadsCount = 0

  landingLeadsCount = 0

  totalLeadsCount = 0

  interestedCount = 0

  conversionsCount = 0

  acquiredCustomersCount = 0

  newSubscriptionsCount = 0

  costPerLeadAmount = 0

  costPerAcquiredCustomerAmount = 0

  conversionRatePercentage = 0

  constructor(data: Partial<AdminGrowthInvestmentSummary> = {}) {
    Object.assign(this, data)
  }
}
